module.exports = __webpack_public_path__ + "static/media/nodejs-logo.8bed0065.svg";